// ═══════════════════════════════════════════════════════════════════
//  modules/projets/CategoryKanban.js
//  CategoryKanban
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { CATEGORY_LABELS } from "./constantes";
import { NewTaskModal } from "./NewTaskModal";
import { TaskCard } from "./TaskCard";

export function CategoryKanban({ token, projectId, category, onBack }) {
  const [tasks, setTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const catInfo = CATEGORY_LABELS[category];

  const loadTasks = useCallback(async () => {
    const res = await fetch(`${API_BASE}/api/projects/${projectId}/tasks`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    setTasks(Array.isArray(data) ? data.filter((t) => t.category === category) : []);
  }, [category, projectId, token]);

  useEffect(() => {
    loadTasks();
    const interval = setInterval(loadTasks, 6000);
    return () => clearInterval(interval);
  }, [category, loadTasks]);

  const columns = [
    { key: "a_faire", label: "À faire", color: THEME.textMuted },
    { key: "en_cours", label: "En cours", color: THEME.amber },
    { key: "termine", label: "Terminé", color: THEME.emerald },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={onBack} style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 6, padding: "6px 12px", cursor: "pointer", fontSize: 13 }}>← Retour</button>
          <h2 style={{ color: catInfo.color, fontSize: 18, fontWeight: 700, margin: 0 }}>{catInfo.label}</h2>
        </div>
        <button onClick={() => setShowModal(true)} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>+ Nouvelle tâche</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14 }}>
        {columns.map((col) => {
          const colTasks = tasks.filter((t) => t.status === col.key);
          return (
            <div key={col.key} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, paddingBottom: 10, borderBottom: `1px solid ${THEME.border}` }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: col.color }} />
                <span style={{ color: col.color, fontWeight: 700, fontSize: 13, textTransform: "uppercase" }}>{col.label}</span>
                <span style={{ marginLeft: "auto", background: THEME.surface, color: THEME.textMuted, borderRadius: 10, padding: "1px 8px", fontSize: 11 }}>{colTasks.length}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {colTasks.map((t) => <TaskCard key={t.id} task={t} token={token} onUpdated={loadTasks} />)}
                {colTasks.length === 0 && <div style={{ color: THEME.textDim, fontSize: 12, textAlign: "center", padding: 12 }}>Aucune tâche</div>}
              </div>
            </div>
          );
        })}
      </div>
      {showModal && <NewTaskModal token={token} projectId={projectId} defaultCategory={category} onClose={() => setShowModal(false)} onCreated={loadTasks} />}
    </div>
  );
}
